import { ControlFacet } from '../models/controls/ControlFacet';
import { IWizardActionStateProps } from '../components/wizardAction/WizardAction';

export interface IMalwareDetectedWizardProps extends IWizardActionStateProps {
  itemKey: string;
  allowInfectedDownload?: boolean;
  infectedItemUrl?: string;
}

export const malwareDetectedControl: ControlFacet<{
  itemKey: string;
}, {
    isAvailable: boolean;
    allowInfectedDownload?: boolean;
    infectedItemUrl?: string;
    malwareDetectedWizard: React.ComponentType<IMalwareDetectedWizardProps>;
  }> = new ControlFacet('malwareDetectedControl');
